import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SeoHelmet = ({ 
  title = "Sydea",
  description = "Sydea - ERP Solutions & Digital Transformation",
  image = "https://www.sydea.com/images/logo/sydea-logo.png",
  canonical,
  schema,
  noIndex = false,
 }) => {
  const location = useLocation();

  // const currentLang = location.pathname.startsWith('/it') ? 'it' : 'en';
  const currentLang = location.pathname === '/it' || location.pathname.startsWith('/it/') ? 'it' : 'en';
  const currentPath = location.pathname;
  
  const baseUrl = "https://www.sydea.com";
  const currentUrl = canonical || `${baseUrl}${currentPath}`;

  // Versioni IT/EN della stessa pagina
  const itPath = currentPath === '/en' || currentPath.startsWith('/en/')
    ? currentPath.replace(/^\/en/, '/it')
    : currentPath;

  const enPath = currentPath === '/it' || currentPath.startsWith('/it/')
    ? currentPath.replace(/^\/it/, '/en')
    : currentPath;

  const noIndexSuffixes = [
    '/title',
    '/desc',
    '/meta-title',
    '/meta-description',
    '/orderMenu'
  ];

  const isNoIndexPage = noIndexSuffixes.some(suffix => currentPath.endsWith(suffix));

  return (
    <Helmet>
      <html lang={currentLang} />

      <title>{title}</title>
      <meta name="description" content={description} />

      <meta
        name="robots"
        content={noIndex || isNoIndexPage ? "noindex,nofollow" : "index,follow"}
      />

      <link rel="canonical" href={currentUrl} />

      <link rel="alternate" hrefLang="it" href={`${baseUrl}${itPath}`} />
      <link rel="alternate" hrefLang="en" href={`${baseUrl}${enPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${baseUrl}/en`} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Sydea" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={currentLang === 'it' ? 'it_IT' : 'en_US'} />
      <meta property="og:locale:alternate" content={currentLang === 'it' ? 'en_US' : 'it_IT'} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      {schema && (
        Array.isArray(schema)
          ? schema.map((s, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(s)}
              </script>
            ))
          : (
              <script type="application/ld+json">
                {JSON.stringify(schema)}
              </script>
            )
      )}

    </Helmet>
  );
};

export default SeoHelmet;



// import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useLocation } from 'react-router-dom';

// const SeoHelmet = ({ title, description }) => {
//   const location = useLocation();
//   const currentLang = location.pathname.startsWith('/it') ? 'it' : 'en';
//   const currentPath = location.pathname;

//   const noIndexSuffixes = [
//     '/title',
//     '/desc',
//     '/meta-title',
//     '/meta-description',
//     '/orderMenu'
//   ];

//   const isNoIndexPage = noIndexSuffixes.some(suffix => currentPath.endsWith(suffix));

//   return (
//     <Helmet>
//       <html lang={currentLang} />
//       <title>{title}</title>
//       <meta name="description" content={description} />

//       <link rel="alternate" hreflang="en" href="https://www.sydea.com/en" />
//       <link rel="alternate" hreflang="it" href="https://www.sydea.com/it" />
//       <link rel="alternate" hreflang="x-default" href="https://www.sydea.com/en" />

//       {isNoIndexPage && <meta name="robots" content="noindex" />}
//     </Helmet>
//   );
// };

// export default SeoHelmet;


